import { STATUS_COLORS } from '../constants/statusColors';
import { STATUS_LABELS } from '../api/adapters';
import type { RequestStatus } from '../types/app';

type Props = {
  status: RequestStatus;
  className?: string;
};

export function StatusBadge({ status, className = '' }: Props) {
  const colors = STATUS_COLORS[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${colors.bg} ${colors.text} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {STATUS_LABELS[status]}
    </span>
  );
}

type GenericBadgeProps = {
  label: string;
  variant?: 'success' | 'danger' | 'warning' | 'info' | 'muted' | 'accent';
  className?: string;
};

const genericVariants: Record<NonNullable<GenericBadgeProps['variant']>, string> = {
  success: 'bg-success-bg text-success',
  danger: 'bg-danger-bg text-danger',
  warning: 'bg-warning-bg text-warning',
  info: 'bg-info-bg text-info',
  muted: 'bg-surface-raised text-muted',
  accent: 'bg-accent-bg text-accent',
};

export function Badge({ label, variant = 'muted', className = '' }: GenericBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${genericVariants[variant]} ${className}`}
    >
      {label}
    </span>
  );
}
